// src/store/actions/userActions.js
export const SET_USER = "SET_USER";

export const setUser = (user) => {
  return {
    type: SET_USER,
    payload: user,
  };
};
